<template>
    <div class="Home">
        <b-row class="no-gutters">
            <b-col md="12" lg="12" xl="5">
                <div class="main-image" v-bind:style="{ height: mainLeftHeight + 'px' }">
                    <div class="event-title">
                        <h1>
                            {{ $t('event_title')}}
                        </h1>
                        <!-- <b-button target="blank" href="https://docs.google.com/forms/d/e/1FAIpQLSfPN9BoPgyGAZpUemdNocfPZfkEOVizj4TJ6YM7IdnMmsrQJw/viewform?usp=sf_link" variant="primary" class="mr-1" size="lg">{{$t('sign_up')}}</b-button>
					<b-button target="blank" href="https://www.youtube.com/watch?v=nn98nVlG-5M&feature=youtu.be" variant="primary" size="lg">{{$t('directSeeding')}}</b-button> -->
                    </div>
                    <MainLeft />
                </div>
            </b-col>
            <b-col md="12" lg="12" xl="7">
                <div class="orginin" v-html="$t('origin')"></div>
                <Agenda />
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Agenda from '@/components/Agenda.vue';
    import MainLeft from '@/components/MainLeft.vue';
    export default {
        name: 'Home',
        data() {
            return {
                mainLeftHeight: 0
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },

        methods: {
            handleResize() {
                return this.mainLeftHeight = window.innerHeight - 120;
            }
        },
        components: {
            Agenda,
            MainLeft
        }
    }
</script>

<style lang="scss">
    .orginin {
        border-top: 2px solid #ced4da;
        padding: 2rem;
        background-color: #f5f5f5;
    }
</style>